export const setSecurityQuestions = (securityQuestions) => ({
  type: 'SET_SECURITY_QUESTIONS',
  securityQuestions
});